/* Loading.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./Loading.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { useIntl } from 'react-intl-next';
import { fontFallback } from '@atlaskit/theme/typography';
import VisuallyHidden from '@atlaskit/visually-hidden';
import { AI_MODAL_SCREEN_CLASS } from '../../../utils/constants';
import LoadingIcon from '../../assets/Loading';
import { CancelEscButton } from '../../components/CancelEscButton/CancelEscButton';
import { FloatingContainer } from '../../components/FloatingContainer/FloatingContainer';
import { Footer } from '../../components/Footer/Footer';
import { LatestPromptHeader } from '../../components/LatestPromptHeader/LatestPromptHeader';
import messages from './messages';
var commonTextStyles = null;
var defaultPaddingStyles = null;

// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var previewContainer = null;
var layoutStyles = null;

// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var logoStyles = null;
var titleLayoutStyles = null;

// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var titleStyles = [titleLayoutStyles, commonTextStyles];

/**
 * Could be either:
 * - userInput only (free form generate / interrogate)
 * - presetTitle only (summarize)
 * - both presetTitle and userInput (brainstorm)
 */

export var LoadingScreen = function LoadingScreen(_ref) {
  var parentPresetPromptLabel = _ref.parentPresetPromptLabel,
    childShortTitle = _ref.childShortTitle,
    presetPromptLabel = _ref.presetPromptLabel,
    title = _ref.title,
    latestPrompt = _ref.latestPrompt,
    preview = _ref.preview,
    providerFactory = _ref.providerFactory,
    schema = _ref.schema,
    onCancel = _ref.onCancel,
    agent = _ref.agent,
    disclaimer = _ref.disclaimer,
    additionalFooterText = _ref.additionalFooterText;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  return /*#__PURE__*/React.createElement(FloatingContainer, {
    "data-testid": "loading-screen"
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    ,
    className: "loading-screen ".concat(AI_MODAL_SCREEN_CLASS),
    rainbowBorderAnimation: true,
    disablePadding: true
  }, /*#__PURE__*/React.createElement(VisuallyHidden, null, formatMessage(messages.loadingAriaTitle)), /*#__PURE__*/React.createElement(LatestPromptHeader, {
    parentPresetPromptLabel: parentPresetPromptLabel,
    childShortTitle: childShortTitle,
    prompt: latestPrompt === null || latestPrompt === void 0 ? void 0 : latestPrompt.userInput,
    promptADF: latestPrompt === null || latestPrompt === void 0 ? void 0 : latestPrompt.userADFInput,
    presetTitle: latestPrompt === null || latestPrompt === void 0 ? void 0 : latestPrompt.presetTitle,
    providerFactory: providerFactory,
    schema: schema,
    agent: agent,
    showBack: true
  }), preview && /*#__PURE__*/React.createElement("div", {
    "data-testid": "adf-content-live-region",
    "aria-atomic": "false",
    "aria-live": "polite",
    className: ax(["_x3dopp12 _n7zlpp12", "_ca0qutpp _n3tdutpp _19bvutpp _u5f3utpp"]),
    style: {
      "--_18x9sjc": ix("1px solid ".concat("var(--ds-border, #091E4224)"))
    }
  }, /*#__PURE__*/React.createElement(VisuallyHidden, {
    testId: "description"
  }, formatMessage(messages.liveRegionDescription)), preview), /*#__PURE__*/React.createElement("div", {
    className: ax(["_ca0qutpp _n3tdutpp _19bvutpp _u5f3utpp", "_1e0c1txw _2lx2vrvc _1bah1e5h _4cvr1h6o _1n261g80"])
  }, /*#__PURE__*/React.createElement("div", {
    "data-testid": "loading-icon",
    className: ax(["_2hwx14y2 _1e0c1txw _4cvr1h6o"])
  }, /*#__PURE__*/React.createElement(LoadingIcon, {
    alt: formatMessage(messages.iconAltText)
  })), /*#__PURE__*/React.createElement("div", {
    className: ax(["_16jlkb7n _1o9zkb7n _i0dlf1ug", "_1nmz1hna _zzcc4f4w _x3fxnil1 _u6rdk9i7 _v2glf7ua"])
  }, title), /*#__PURE__*/React.createElement(CancelEscButton, {
    autoFocus: true,
    onCancel: onCancel
  })), /*#__PURE__*/React.createElement(Footer, {
    brand: agent ? 'rovo' : 'atlassian-intelligence',
    disclaimer: disclaimer,
    showDisclaimer: true
  }));
};